import React from 'react';
import { Form, Select } from 'antd';
import { useLectureCode } from 'hooks';
import { selectBoxFilterOption } from 'utils/form-utils';

interface FormItemProps {
  form: any;
  disable: boolean;
  onSelected: (opt: LectureCodeListDto) => void;
}

const LecturerFormItem = ({form, disable = false, onSelected}: FormItemProps): React.ReactElement => {
  /* ======================================================
   * variables
   * ====================================================== */

  /* ======================================================
  * hooks
  * ====================================================== */
  const { lectureCodeList } = useLectureCode();  
  /* ======================================================
   * effects
   * ====================================================== */

  /* ======================================================
   * render items
   * ====================================================== */
  return (
    <>
      <Form.Item name="lecture_gid" style={{ display: 'inline-block', marginRight: '5px' }}>
        <Select 
          style={{width:'250px'}} 
          placeholder={'과정'}
          virtual={false}
          showSearch={true} 
          options={lectureCodeList}       
          optionFilterProp="label"     
          filterOption={selectBoxFilterOption}
          onChange={(value, option)=>onSelected(option)}
          disabled={disable}
        />                
      </Form.Item> 
    </>
  );
};

export default LecturerFormItem;
